// src/components/ProductCard.js
import React from 'react';
import { Card } from 'react-bootstrap';
import './ProductCard.css';
import ReactMarkdown from 'react-markdown';

const ELECTRON_URL = process.env.REACT_APP_ELECTRON_URL;

const ProductCard = ({ product, showDescription = true }) => {
  const handleClick = () => {
    window.location.href = `${ELECTRON_URL}/${product.store_handle}/product/${product.slug || product._id}`;
  };

  // Get the first letter of the store name
  const getStoreInitial = () => {
    if (product.store_name) {
      return product.store_name.charAt(0).toUpperCase();
    }
    if (product.storeName) {
      return product.storeName.charAt(0).toUpperCase();
    }
    if (product.store_handle) {
      return product.store_handle.charAt(0).toUpperCase();
    }
    return 'S'; // Default fallback
  };

  // Generate a color based on the store initial
  const getInitialBackgroundColor = () => {
    const initial = getStoreInitial();
    
    // Simplified direct mapping
    switch(initial) {
      case 'A': return '#FF6F61';  // Retro Coral
      case 'B': return '#6B5B95';  // Dusty Purple
      case 'C': return '#88B04B';  // Avocado Green
      case 'D': return '#F7CAC9';  // Pastel Pink
      case 'E': return '#92A8D1';  // Soft Blue
      case 'F': return '#955251';  // Vintage Rosewood
      case 'G': return '#B565A7';  // Retro Lavender
      case 'H': return '#009B77';  // Classic Teal Green
      case 'I': return '#DD4124';  // Burnt Orange Red
      case 'J': return '#D65076';  // Neon Pink
      case 'K': return '#45B8AC';  // Minty Teal
      case 'L': return '#EFC050';  // Mustard Yellow
      case 'M': return '#5B5EA6';  // Indigo Blue
      case 'N': return '#9B2335';  // Maroon
      case 'O': return '#DFCFBE';  // Beige Cream
      case 'P': return '#BC243C';  // Cranberry Red
      case 'Q': return '#C3447A';  // Fuchsia Rose
      case 'R': return '#98B4D4';  // Faded Sky Blue
      case 'S': return '#E15D44';  // Rustic Orange
      case 'T': return '#7FCDCD';  // Soft Cyan
      case 'U': return '#C94C4C';  // Brick Red
      case 'V': return '#FFA07A';  // Light Salmon
      case 'W': return '#A2836E';  // Coffee Brown
      case 'X': return '#C0B283';  // Retro Khaki
      case 'Y': return '#F4A460';  // Sandy Tan
      case 'Z': return '#B4C6A6';  // Sage Green
      default:  return '#A9A9A9';  // Default Retro Gray
    }
  };

  return (
    <Card className="product-card" onClick={handleClick} style={{ position: 'relative' }}>
      {/* Store logo or initial in top-right corner, unless store_logo is 'none' */}
      {product.store_logo === 'none' ? null : (
        product.store_logo ? (
          <img
            src={product.store_logo}
            alt={`${product.storeName || product.store_name} logo`}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              border: '2px solid white',
              backgroundColor: 'white',
              padding: '2px',
              objectFit: 'cover',
              boxSizing: 'border-box',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
              zIndex: 2
            }}
          />
        ) : (
          <div
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              border: '2px solid white',
              backgroundColor: getInitialBackgroundColor(),
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '700',
              fontSize: '18px',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
              zIndex: 2,
              padding: 0,
              overflow: 'hidden',
              textShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)'
            }}
          >
            {getStoreInitial()}
          </div>
        )
      )}
      <Card.Img variant="top" src={product.images?.[0]?.cropped_url || '/placeholder-image.jpg'} />
      <Card.Body className="product-card-body">
        <Card.Title
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {product.name}
        </Card.Title>
        {typeof product.author_name === 'string' && product.author_name && (
          <Card.Text>{product.author_name}</Card.Text>
        )}
        {showDescription && (
          <Card.Text><ReactMarkdown>{product.description}</ReactMarkdown></Card.Text>
        )}
        {product.type !== 'showcase' && product.price ? (
          <Card.Text>${product.price / 100}</Card.Text>
        ) : null}
      </Card.Body>
    </Card>
  );
};

export default ProductCard;


